import React from "react";

// Constelação aberta: dimensões ilustrativas, sem centro, hierarquia ou setas.
const N = [
    { id: "eco", x: 84, y: 92, label: "econômica", dx: 0, dy: -14, a: "middle" },
    { id: "tec", x: 296, y: 66, label: "tecnológica", dx: 0, dy: -14, a: "middle" },
    { id: "soc", x: 206, y: 136, label: "social", dx: 12, dy: 4, a: "start" },
    { id: "hum", x: 66, y: 238, label: "humana", dx: 0, dy: 22, a: "middle" },
    { id: "amb", x: 328, y: 206, label: "ambiental", dx: 0, dy: 22, a: "middle" },
    { id: "ins", x: 146, y: 320, label: "institucional", dx: 0, dy: 22, a: "middle" },
    { id: "pol", x: 286, y: 332, label: "política e regulatória", dx: 0, dy: 22, a: "middle" },
];
const P = Object.fromEntries(N.map((n) => [n.id, n]));

const E = [
    ["eco", "soc", 18, -20, null],
    ["soc", "tec", -10, 14, "3 5"],
    ["soc", "amb", 30, 12, null],
    ["amb", "pol", -14, -8, null],
    ["pol", "ins", 10, -26, "6 5"],
    ["ins", "hum", -6, -22, "partial"],
    ["hum", "soc", 14, 26, "1 6"],
    ["eco", "hum", -22, 10, "partial"],
];

const FeedbackLoops = ({ light = true }) => {
    const ink = light ? "#0E2018" : "#F2EFE5";
    return (
        <svg data-testid="feedback-loops-diagram" viewBox="0 0 400 400" className="w-full h-auto overflow-visible" role="img"
            aria-label="Constelação aberta e ilustrativa de dimensões possíveis — econômica, tecnológica, social, humana, ambiental, institucional, política e regulatória — inseridas em um contexto em transformação, sem hierarquia fixa">
            <defs>
                <radialGradient id="campo-a" cx="50%" cy="50%" r="50%">
                    <stop offset="0%" stopColor="#C7A659" stopOpacity="0.16" />
                    <stop offset="100%" stopColor="#C7A659" stopOpacity="0" />
                </radialGradient>
                <radialGradient id="campo-b" cx="50%" cy="50%" r="50%">
                    <stop offset="0%" stopColor="#0E2018" stopOpacity="0.07" />
                    <stop offset="100%" stopColor="#0E2018" stopOpacity="0" />
                </radialGradient>
            </defs>
            <g data-testid="constelacao-contexto">
                <ellipse cx="150" cy="170" rx="170" ry="130" fill="url(#campo-a)">
                    <animate attributeName="cx" values="150;175;150" dur="24s" repeatCount="indefinite" />
                </ellipse>
                <ellipse cx="270" cy="270" rx="160" ry="120" fill="url(#campo-b)">
                    <animate attributeName="cy" values="270;245;270" dur="30s" repeatCount="indefinite" />
                </ellipse>
                <path d="M10,300 C80,250 120,380 210,360 S330,250 395,290" fill="none" stroke="#8a6a22" strokeOpacity="0.22" strokeDasharray="1 7" />
                <path d="M0,150 C70,120 110,200 180,190 S300,90 390,130" fill="none" stroke="#8a6a22" strokeOpacity="0.16" strokeDasharray="1 7" />
                <text x="6" y="380" fontSize="11" letterSpacing="2" fill="#8a6a22" className="font-sans uppercase">contexto em transformação</text>
                <text x="6" y="396" fontSize="11" letterSpacing="2" fill="#8a6a22" fillOpacity="0.8" className="font-sans uppercase">— parte ativa do sistema</text>
            </g>
            {E.map(([a, b, kx, ky, dash]) => {
                const p = P[a], q = P[b];
                return (
                    <path key={a + b} d={`M${p.x},${p.y} Q${(p.x + q.x) / 2 + kx},${(p.y + q.y) / 2 + ky} ${q.x},${q.y}`} fill="none"
                        stroke={ink} strokeOpacity={dash ? 0.32 : 0.45} strokeWidth="0.9" pathLength={dash === "partial" ? 1 : undefined}
                        strokeDasharray={dash === "partial" ? "0.5 1" : dash || undefined} />
                );
            })}
            {N.map((n) => (
                <g key={n.id} data-testid={`dimensao-${n.id}`}>
                    <circle cx={n.x} cy={n.y} r="6" fill={light ? "#F2EFE5" : "#0E2018"} stroke={ink} strokeWidth="1" />
                    <circle cx={n.x} cy={n.y} r="2.2" fill="#C7A659" />
                    <text x={n.x + n.dx} y={n.y + n.dy} textAnchor={n.a} fontSize="15" fill={ink} className="font-serif" fontStyle="italic">{n.label}</text>
                </g>
            ))}
        </svg>
    );
};

export default FeedbackLoops;
